export const STORY_GRADIENTS = {
  grad1: "linear-gradient(135deg, #6C0BA9 0%, #E024A3 100%)",
  grad2: "linear-gradient(135deg, #1e3a8a 0%, #06b6d4 100%)",
  grad3: "linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)",
  grad4: "linear-gradient(135deg, #059669 0%, #84cc16 100%)",
  grad5: "linear-gradient(135deg, #0f172a 0%, #6b7280 100%)",
  grad6: "linear-gradient(135deg, #db2777 0%, #fb923c 100%)",
};

export const DEFAULT_GRADIENT = "grad1";

export const STORY_EMOJIS = ["❤️", "😂", "😮", "👍", "🔥", "😢"];
